import { memo } from "react";
import {
  Box,
  Button,
  Stack,
} from "@mui/material";

const EcommerceItem = ({ ecommerce, logoSrc, onOpenConfig, onDeleteClick }) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ py: 1.5, borderBottom: "1px solid #eee" }}
    >
      <img
        src={logoSrc}
        alt=""
        style={{ width: 60, height: 60, objectFit: "contain" }}
      />
      <Box>
        <Button
          variant="outlined"
          size="small"
          onClick={onOpenConfig}
          sx={{ mr: 1 }}
        >
          Configurar
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={onDeleteClick}
          sx={{
            color: "#d32f2f !important",
            borderColor: "#d32f2f !important",
            mr: 2,
            maxWidth: 80,
          }}
        >
          Eliminar
        </Button>
      </Box>
    </Stack>
  );
};

export default memo(EcommerceItem);
